import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import api from '../../api/client'

export default function Aceite() {
  const { token } = useParams()
  const [info, setInfo] = useState(null)
  const [estado, setEstado] = useState('carregando') // carregando, ok, erro, aceito, recusado

  useEffect(() => {
    api.get(`/aceite/${token}`).then((r) => { setInfo(r.data); setEstado('ok') }).catch(() => setEstado('erro'))
  }, [token])

  async function confirmar() {
    await api.post(`/aceite/${token}`)
    setEstado('aceito')
  }
  async function recusar() {
    await api.post(`/aceite/${token}/recusar`)
    setEstado('recusado')
  }

  return (
    <div className="min-h-screen bg-tc-graphite flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full shadow-xl">
        <div className="font-heading text-xl font-extrabold text-tc-graphite mb-4">
          The Conect <span className="text-tc-orange">Energy</span>
        </div>

        {estado === 'carregando' && <p className="text-tc-smoke">Carregando termo...</p>}
        {estado === 'erro' && <p className="text-red-600">Termo não encontrado ou expirado.</p>}
        {estado === 'aceito' && <p className="text-green-600 font-medium">✓ Aceite confirmado! Seu cadastro foi ativado.</p>}
        {estado === 'recusado' && <p className="text-tc-smoke">Você recusou o termo.</p>}

        {estado === 'ok' && info && (
          <>
            <p className="text-sm text-tc-smoke mb-1">Olá {info.cliente?.nome},</p>
            {info.oferta && (
              <div className="bg-gray-50 rounded-lg p-3 my-3 text-sm">
                <p className="font-medium">{info.oferta.nome}</p>
                <p className="text-tc-smoke">{info.oferta.descricao}</p>
                <p className="text-tc-orange mt-1">PV: {info.pv}</p>
              </div>
            )}
            <p className="text-sm text-tc-graphite my-4">{info.termo_texto}</p>
            <div className="flex gap-3">
              <button onClick={confirmar} className="flex-1 rounded-lg bg-tc-orange text-white py-2.5 font-semibold">
                Aceito
              </button>
              <button onClick={recusar} className="rounded-lg border border-gray-200 px-4 py-2.5 text-tc-smoke">
                Recusar
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
